<template>
  <DashboardWidgetGauge class="widget-roi" :loading="loading" title="ROI | Return on Investment" :min="min" :max="max" :value="value" />
</template>

<script>

export default {
  name: 'dashboard-widget-roi',
  components: {
    DashboardWidgetGauge: () => import('../BaseWidgets/DashboardWidgetGauge'),
  },
  props: {
    min: {
      type: Number,
      default: 5,
    },
    max: {
      type: Number,
      default: 8,
    },
    value: {
      type: Number,
    },
  },
  data () {
    return {
      loading: false,
    };
  },
};

</script>
